import { render, staticRenderFns } from "./FeatureCardKomadres.vue?vue&type=template&id=a6796abc&"
import script from "./FeatureCardKomadres.vue?vue&type=script&lang=js&"
export * from "./FeatureCardKomadres.vue?vue&type=script&lang=js&"
import style0 from "./FeatureCardKomadres.vue?vue&type=style&index=0&id=a6796abc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports